var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "el-row",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.historyBack },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "headDataForm",
                  attrs: {
                    model: _vm.headData,
                    "label-position": _vm.labelPosition,
                    "label-width": "140px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("apply.no") } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.headData.applyNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.headData, "applyNo", $$v)
                                  },
                                  expression: "headData.applyNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("apply.subject") } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.headData.subject,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.headData, "subject", $$v)
                                  },
                                  expression: "headData.subject",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "入围供应商" } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.supplierNames,
                                  callback: function ($$v) {
                                    _vm.supplierNames = $$v
                                  },
                                  expression: "supplierNames",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("apply.quotationType") } },
                            [
                              _c("ic-select", {
                                staticClass: "handle-input",
                                attrs: {
                                  disabled: "true",
                                  table: "TT_QUOTATION_APPLY",
                                  field: "QUOTATION_TYPE",
                                },
                                model: {
                                  value: _vm.headData.quotationType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.headData, "quotationType", $$v)
                                  },
                                  expression: "headData.quotationType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "历史报价", name: "line" } },
                _vm._l(_vm.roundList, function (round, i) {
                  return _c(
                    "div",
                    { key: i },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 16 } },
                        [
                          _c("el-col", { attrs: { span: 2 } }, [
                            _vm._v(_vm._s(_vm.$t("apply.round")) + "："),
                          ]),
                          _c("el-col", { attrs: { span: 1 } }, [
                            _vm._v(_vm._s(round.roundNumber)),
                          ]),
                          _c("el-col", { attrs: { span: 3 } }, [
                            _vm._v(
                              _vm._s(_vm.$t("apply.quoteSubmitDate")) + "："
                            ),
                          ]),
                          _c(
                            "el-col",
                            { attrs: { span: 3 } },
                            [
                              _c("el-link", [
                                _vm._v(" " + _vm._s(round.submitDate) + " "),
                              ]),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 2 } }, [
                            _vm._v(_vm._s(_vm.$t("apply.roundRemark")) + "："),
                          ]),
                          _c("el-col", { attrs: { span: 4 } }, [
                            _vm._v(_vm._s(round.remark)),
                          ]),
                          _c(
                            "el-col",
                            { attrs: { span: 2 } },
                            [
                              _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showAttachmentDialogM(
                                        _vm.$t("apply.roundAttachment"),
                                        round.ttQuotationApplyRoundId,
                                        "QUOTATION_APPLY_ROUND"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("apply.roundAttachment"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 3 } },
                            [
                              _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showQuotationAttachmentDialogM(
                                        round.ttQuotationId,
                                        round.supplierList
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("apply.quoteAttachment"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          ref: "quotationLineTableDataRef",
                          refInFor: true,
                          staticClass: "table",
                          attrs: {
                            data: round.quotationProductList,
                            "row-class-name": _vm.tableRowClassName,
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "supplierName",
                              fixed: "",
                              label: "供应商",
                              "min-width": "200px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "eightBitCode",
                              width: "80",
                              label: "8位码",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "eightBitCodeName",
                              label: "8位码名称",
                              "min-width": "120px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "pickupPoint",
                              label: _vm.$t("apply.shippingCity"),
                              "min-width": "120px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "dcName",
                              label: _vm.$t("apply.arrivalAarehouse"),
                              "min-width": "250",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "temperatureI18n",
                              label: _vm.$t("apply.temperature"),
                              "min-width": "120px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "lineUnit",
                              label: "结算单位",
                              "min-width": "120px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "transportaionMethod",
                              label: _vm.$t("apply.transportaionMethod"),
                              "min-width": "120px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "effectiveBeginDate",
                              label: _vm.$t("apply.effectiveBeginDate"),
                              "min-width": "120px",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("dateFormatFilter")(
                                              scope.row.effectiveBeginDate,
                                              "YYYY-MM-DD"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "linePrice",
                              label: "线路价格",
                              "min-width": "130px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "isSpecialFreight",
                              width: "100",
                              label: "非标准线路运费",
                              formatter: _vm.formatisSpecial,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "productPrice",
                              width: "150",
                              label: "产品运费（不含税）",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "currencyCode",
                              label: _vm.$t("apply.currency"),
                              "min-width": "120px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "leadTime",
                              label: "Leadtime",
                              "min-width": "120px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "externalPackagingLength",
                              label: "外包装长(cm)",
                              "min-width": "120px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "externalPackagingWidth",
                              label: "外包装宽(cm)",
                              "min-width": "120px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "externalPackagingHeight",
                              label: "外包装高(cm)",
                              "min-width": "120px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "externalPackagingNetweight",
                              label: "外包装净重(kg)",
                              "min-width": "130px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "externalPackagingGrossweight",
                              label: "外包装毛重(kg)",
                              "min-width": "130px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "palletLayerNumber",
                              label: "每Pallet层数",
                              "min-width": "120px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "palletLayerBoxNumber",
                              label: "每层箱数",
                              "min-width": "100px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "remarks",
                              label: _vm.$t("common.remarks"),
                              "min-width": "120px",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "sourcingProductStatus",
                              label: _vm.$t("apply.sourcingApprovalStatus"),
                              "min-width": "150px",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.showAttachmentDialog,
            "append-to-body": "",
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAttachmentDialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "table",
              attrs: {
                data: _vm.attachmentList,
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "documentName",
                  label: "文件",
                  "min-width": "130px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.downloadFile(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.documentName) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "userName",
                  label: "创建人",
                  "min-width": "130px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "createDate",
                  label: "创建时间",
                  "min-width": "130px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("dateFormatFilter")(
                                scope.row.createDate,
                                "YYYY-MM-DD HH:mm"
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("apply.quoteAttachment"),
            visible: _vm.showQuotationAttachmentDialog,
            "append-to-body": "",
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showQuotationAttachmentDialog = $event
            },
          },
        },
        _vm._l(_vm.supplierList, function (supplier, ix) {
          return _c(
            "el-row",
            { key: ix, attrs: { align: "middle", gutter: 10 } },
            [
              _c("el-col", { attrs: { span: 4 } }, [
                _vm._v(" " + _vm._s(supplier.supplierName) + " "),
              ]),
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "table",
                      attrs: {
                        data: _vm.fileList[ix],
                        border: "",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          sortable: "",
                          prop: "documentName",
                          label: _vm.$t("common.file"),
                          "min-width": "130px",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: { type: "primary" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.downloadFile(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row.documentName) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          sortable: "",
                          prop: "userName",
                          label: _vm.$t("common.createBy"),
                          "min-width": "130px",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          sortable: "",
                          prop: "createDate",
                          label: _vm.$t("common.createDate"),
                          "min-width": "130px",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("dateFormatFilter")(
                                          scope.row.createDate,
                                          "YYYY-MM-DD HH:mm"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }